import { lazy } from 'react';

// project imports
import Loadable from 'ui-components/loadhandlers/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

const HostSignup = Loadable(lazy(() => import('views/public/signup-host')));
const HostLogin = Loadable(lazy(() => import('views/public/login-host')));
const HostWelcome = Loadable(lazy(() => import('views/host-welcome')));

// ==============================|| TRAVEL HOST ROUTING ||============================== //

/*
 * The travel host screens that render *without* the app shell.
 *
 * Everything a signed-in host actually works in — the application wizard, the
 * services hub, the packages hub and the package builder — lives in
 * routes/UserRoutes.jsx so it inherits MainLayout, with the header, the sidebar
 * and the account menu a host expects on every other page. What is left here is
 * the two anonymous screens, which have no session to draw a menu from, and the
 * approval landing, which is a full-bleed one-time celebration.
 *
 * Registration order in routes/index.jsx does not matter. React Router 6.25
 * ranks matched branches by specificity, not array position, so
 * AuthenticationRoutes' `path: '*'` catch-all cannot swallow `/host/*` — the
 * same reason `/onboarding` resolves today despite being registered after it.
 */
const HostRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      // Steps 01–02: host type then account, two stages of one mount.
      path: '/host/signup',
      element: <HostSignup />
    },
    {
      path: '/host/login',
      element: <HostLogin />
    },
    {
      /*
       * Deliberately still chrome-less. It is the one screen a host sees once,
       * the moment they are approved, and its full-bleed coral banner is the
       * whole point of it. Its primary action goes straight to `/host`, which
       * does have the shell.
       */
      path: '/host/welcome',
      element: <HostWelcome />
    }
  ]
};

export default HostRoutes;
